<template>
    <div class="logo">
        <a class="logo__link" href="javascript:void(0)">
            <svg class="logo__img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 611 85">
                <path d="M122.07,52.14,110.84,63.85V85H91.59V1.35h19.25V40.42L147.9,1.35h21.52L134.75,38.63,171.45,85h-22.6Z" />
                <path d="M225.18,55.36V85H205.82V55.12L173.42,1.35H194l22.36,37.16L238.69,1.35h19Z" />
                <path d="M333.59,69.23V85H260.42V72.45l45.91-55.33H261.38V1.35H331.8V13.89L286,69.23Z" />
                <path d="M422.16,85,422,34.81,397.42,76.16h-8.73L364.18,35.88V85H346V1.35h16l31.32,52,30.85-52h15.9L440.34,85Z" />
                <path d="M515.3,67.07H476.45L469,85H449.19l37.3-83.65h19.13L543,85H522.72Zm-6.09-14.69-13.27-32-13.27,32Z" />
                <path d="M564.85,17.12H538.07V1.35H611V17.12H584.22V85H564.85Z" />
                <path d="M4.21,85A3.37,3.37,0,0,1,.84,81.63V37a3.37,3.37,0,0,1,3.37-3.37H16.84A3.37,3.37,0,0,1,20.21,37v44.6A3.37,3.37,0,0,1,16.84,85Z" />
                <path d="M21.89,10.94A10.95,10.95,0,1,1,10.94,0,10.94,10.94,0,0,1,21.89,10.94Z" />
                <path d="M23.16,21H74.93a3.37,3.37,0,0,0,3.37-3.37V4.21A3.37,3.37,0,0,0,74.93.84H23.39A16.27,16.27,0,0,1,23.16,21Z" />
                <path d="M25.45,53V36.43A8.23,8.23,0,0,0,25,33.66H51.36A3.36,3.36,0,0,1,54.72,37V49.65A3.36,3.36,0,0,1,51.36,53Z" />
                <path d="M25,85a8,8,0,0,0,.46-2.7V65.64H74.93A3.37,3.37,0,0,1,78.3,69V81.63A3.37,3.37,0,0,1,74.93,85Z" />
            </svg>
            <span class="logo__descr  logo__descr--dark">{{ getTranslation('testing') }}</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: "LogoComponent"
    }
</script>

<style scoped>

</style>